import c from "classnames";
import { ComponentProps } from "react";
import { NavLink } from "react-router";

import { Icon } from "@design-system/Icon/Icon";
import { Text } from "@design-system/Text/Text";

import classes from "./NavigationItem.module.css";

type Props = {
  name: string;
  icon: ComponentProps<typeof Icon>["icon"];
  to: ComponentProps<typeof NavLink>["to"];
  onClick?: () => void;
};

export const NavigationItem = ({ name, icon, to, onClick }: Props) => {
  return (
    <NavLink
      className={({ isActive }) =>
        c(classes.navigationItem, isActive && classes.active)
      }
      to={to}
      viewTransition
      onClick={onClick}
    >
      <div className={classes.iconContainer}>
        <Icon icon={icon} size="xs" />
      </div>
      <Text size={12} weight={700} uppercase>
        {name}
      </Text>
    </NavLink>
  );
};
